import Marquee from "react-fast-marquee";
import Seekh from "../../assets/Seekh.png";
import AharSeva from "../../assets/Ahar_Seva.png";
import Treeplantation from "../../assets/Tree_plantation.png";
import safewomenOnepad from "../../assets/Safe_Women_One_Pad.png";
import Swasthyabhaavishya from "../../assets/Swasthya_Bhavishya.png";
import Plasticwasteinitiate from "../../assets/Plastic_Waste_Initiate.png";
import LivelihoodProgram from "../../assets/Livelihood_Program.png";

const App = () => {
  let alluser = [
    {
      img: Seekh,
      title: "SEEKH",
      count: "10,000+",
      subtitle: "Children Reached "
    },
    {
      img: AharSeva,
      title: "Ahar Seva",
      count: "1,00,000+",
      subtitle: "Meals Distributed"
    },
    {
      img: Treeplantation,
      title: "Tree plantation",
      count: "1,000+",
      subtitle: "Trees Planted"
    },
    {
      img: safewomenOnepad,
      title: "Safe Women - OnePad",
      count: "50,000+",
      subtitle: "Sanitary Pad distributed"
    },
    {
      img: Swasthyabhaavishya,
      title: "Swasthya Bhavishya",
      count: "20+",
      subtitle: "medical camps conducted"
    },
    {
      img: Plasticwasteinitiate,
      title: "Plastic Waste Initiative",
      count: "1 Ton",
      subtitle: "Plastic bag Collected"
    },
    {
      img: LivelihoodProgram,
      title: "Livelihood Program",
      count: "40+",
      subtitle: "women supported with livelihood opportunities"
    }
  ]

  return (
    <div className="w-full overflow-hidden">
      <div className="w-full bg-white py-12 md:py-16 lg:py-20">
        <Marquee speed={40}>
          {alluser.map((user, idx) => (
            <div key={idx} className="w-[140px] sm:w-[180px] md:w-[220px] lg:w-[260px] mx-4 sm:mx-5 md:mx-6 flex flex-col items-center text-center flex-shrink-0">
              <img
                src={user.img}
                alt={user.title}
                className="w-12 h-12 sm:w-16 sm:h-16 md:w-[72px] md:h-[72px] object-contain"
              />

              <h2 className="mt-2 sm:mt-3 md:mt-4 text-xs sm:text-sm md:text-base font-medium line-clamp-2">
                {user.title}
              </h2>

              <h1 className="font-bold text-xl sm:text-2xl md:text-3xl mt-1 sm:mt-2">
                {user.count}
              </h1>

              <h3 className="text-[10px] sm:text-xs md:text-sm font-light mt-1 line-clamp-2">
                {user.subtitle}
              </h3>
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  )
}

export default App
